/**
 * Base headers used for GraphQL requests
 * FS-1307: Help identify storefront traffic to /hub
 */
export const GRAPHQL_BASE_HEADERS = {
  'x-gstar-fs': '66cc56d9ca18dd906749753179bef439',
  'x-gstar-fs-app': 'storefront',
} as const;

/**
 * Server-side links only. The GraphQL origin serves brotli, but Node's fetch
 * advertises `gzip, deflate` and nothing else, so brotli has to be asked for by
 * hand — undici decodes the response transparently either way.
 *
 * FS-4757: never use these in a browser link. `Accept-Encoding` is a forbidden
 * header name there, so the fetch would silently drop it, and the browser's own
 * (wider) value is the right one anyway.
 */
export const GRAPHQL_SSR_HEADERS = {
  ...GRAPHQL_BASE_HEADERS,
  'accept-encoding': 'br, gzip',
} as const;
